import { ShieldAlert } from "lucide-react"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { formatDateTime } from "@/lib/formatters"
import type { MyEnforcementStatus } from "@/providers/safety.provider"
import { authProvider } from "@/providers/auth.provider"
import { useAuthStore } from "@/stores/auth.store"

export function AccountSuspendedScreen({
  enforcement,
}: {
  enforcement: MyEnforcementStatus
}) {
  const clearSession = useAuthStore((s) => s.clearSession)
  const isPermanent = !enforcement.expires_at

  async function handleLogout() {
    await authProvider.logout().catch(() => {})
    clearSession()
    window.location.href = "/auth"
  }

  return (
    <div className="flex min-h-svh items-center justify-center p-6">
      <Card className="w-full max-w-md">
        <CardHeader>
          <div className="mb-2 flex size-10 items-center justify-center rounded-full bg-destructive/10 text-destructive">
            <ShieldAlert className="size-5" />
          </div>
          <CardTitle>Your account is suspended</CardTitle>
          <CardDescription>
            {isPermanent
              ? "This suspension is permanent."
              : `This suspension lifts on ${formatDateTime(enforcement.expires_at as string)}.`}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="rounded-md border bg-muted/50 p-3 text-sm">
            {enforcement.reason}
          </div>
          <Button variant="outline" className="w-full" onClick={handleLogout}>
            Log out
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
